import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CONTACT_EMAIL, LEGAL_ENTITY, POLICY_VERSION, PROD_DOMAIN } from '../legal.constants';

/** F-034 — static Terms of Service. Content-only; edits ship via deploy. */
@Component({
  selector: 'app-terms',
  imports: [RouterLink],
  templateUrl: './terms.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class Terms {
  protected readonly contactEmail = CONTACT_EMAIL;
  protected readonly legalEntity = LEGAL_ENTITY;
  protected readonly prodDomain = PROD_DOMAIN;
  protected readonly lastUpdated = POLICY_VERSION;
}
